import { Checkbox } from "@/components/ui/checkbox";

interface TeamListHeaderProps {
  checked: boolean;
  indeterminate: boolean;
  onCheckedChange: () => void;
}

export function TeamListHeader({
  checked,
  indeterminate,
  onCheckedChange,
}: TeamListHeaderProps) {
  return (
    <div className="flex h-[52px] items-center gap-4 rounded-t-lg px-5 py-2">
      {/* Checkbox */}
      <Checkbox
        checked={checked}
        indeterminate={indeterminate}
        onCheckedChange={onCheckedChange}
        className="border-gray-400"
      />

      {/* Name section */}
      <div className="flex min-w-0 flex-1 items-center gap-3">
        {/* Name header */}
        <div className="min-w-0 flex-1">
          <p className="text-xs font-medium tracking-wide text-neutral-500 uppercase">
            NAME
          </p>
        </div>
      </div>

      {/* Date Created - hide on small screens */}
      <div className="hidden min-w-0 flex-1 lg:block">
        <p className="-ml-2 text-xs font-medium tracking-wide text-neutral-500 uppercase">
          DATE CREATED
        </p>
      </div>

      {/* Last Used - hide on medium screens */}
      <div className="hidden min-w-0 flex-1 xl:block">
        <p className="-ml-4 text-xs font-medium tracking-wide text-neutral-500 uppercase">
          LAST USED
        </p>
      </div>

      {/* Hash */}
      <div className="min-w-0 flex-[2]">
        <p className="-ml-6 text-xs font-medium tracking-wide text-neutral-500 uppercase">
          HASH
        </p>
      </div>

      {/* Actions */}
      <div className="min-w-[80px] flex-shrink-0 text-left sm:min-w-[120px]">
        <p className="-ml-8 text-xs font-medium tracking-wide text-neutral-500 uppercase">
          ACTIONS
        </p>
      </div>
    </div>
  );
}
